import { getFirebaseToken } from '@/lib/firebase';
import { createApiHandler } from './common';
import { BaseUrl } from './constants';
import { createAuthHeaderValue } from './utils';

// Firebase handles token refresh automatically via onIdTokenChanged in lib/firebase.ts.
// We read the cached token synchronously here; it is always up-to-date.
export const ApiHandler = createApiHandler({
  baseUrl: BaseUrl,
  addAuthHeader: true,
  rejectOnError: false,
  getAuthHeaderValue() {
    return createAuthHeaderValue(getFirebaseToken());
  },
});
